export enum QueryKeys {
  ACCOUNT_ID = 'ACCOUNT_ID',
  ADD_ONS = 'ADD_ONS',
  ALL_COUNTRIES = 'ALL_COUNTRIES',
  AVAILABLE_CURRENCIES = 'AVAILABLE_CURRENCIES',
  BILLING_ACCOUNT = 'BILLING_ACCOUNT',
  EXTENDED_BILLING_ACCOUNT = 'EXTENDED_BILLING_ACCOUNT',
  BILLING_INFO = 'BILLING_INFO',
  SINGLE_BILL = 'SINGLE_BILL',
  SINGLE_BILL_SETUP_ELEMENT = 'SINGLE_BILL_SETUP_ELEMENT',
  IS_SINGLE_BILLED = 'IS_SINGLE_BILLED',
  CONTACTS_COUNT = 'CONTACTS_COUNT',
  ENABLE_AMEX_IR_AFFILIATE = 'ENABLE_AMEX_IR_AFFILIATE',
  FOS_CONTENT = 'FOS_CONTENT',
  PARTNER_NAME = 'PARTNER_NAME',
  PARTNER_SUMMARY = 'PARTNER_SUMMARY',
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  PROMO_VALIDATION = 'PROMO_VALIDATION',
  PLAN_GROUP = 'PLAN_GROUP',
  RATING = 'RATING',
  TRIALER = 'TRIALER',
  CANCELED = 'CANCELED',
  USER_ID = 'USER_ID',
  BUY_NOW_FLAG = 'BUY_NOW_FLAG',
  PLAN_DETAIL = 'PLAN_DETAIL',
  BALANCE = 'BALANCE',
  ENTITLEMENT = 'ENTITLEMENT',
  USER_ROLE = 'USER_ROLE',
  CUSTOMER_INFO = 'CUSTOMER_INFO',
  PARTNER = 'PARTNER',
  PARTNER_OWNER_SUMMARY = 'PARTNER_OWNER_SUMMARY',
  STRIPE_ELEMENTS_CREDENTIALS = 'STRIPE_SETUP_INTENT',
  STRIPE_CUSTOMER = 'STRIPE_CUSTOMER',
  STRIPE_PORTAL = 'STRIPE_PORTAL',
  HAS_SCHEDULED_DOWNGRADE = 'HAS_SCHEDULED_DOWNGRADE',
  SUSPENSION_INFO = 'SUSPENSION_INFO',
  SUSPENDED = 'SUSPENDED',
  HAS_STRIPE_OVERDUE = 'HAS_STRIPE_OVERDUE',
  IS_IMPERSONATED = 'IS_IMPERSONATED',
  SMS_COUNTRY_ELIGIBILITY = 'SMS_COUNTRY_ELIGIBILITY',
  EMAIL_ADDRESSES = 'EMAIL_ADDRESSES',
  UPGRADE_PLAN_PROMOTION = 'UPGRADE_PLAN_PROMOTION',
}
